// extracted by mini-css-extract-plugin
export default {"accordion":"Accordion_accordion__pAy-D","header":"Accordion_header__wzcSj","body":"Accordion_body__+o0se","active":"Accordion_active__hlOrj"};